import { TRENDING_TOOL_IDS } from "./trendingToolsConfig";

/** resize_category ids per trending tool (primary first, Social Media, Standard last). */
export const TRENDING_TOOL_PRESET_CATEGORY_IDS = {
  [TRENDING_TOOL_IDS.EDIT_IMAGES]: [6, 1],
  [TRENDING_TOOL_IDS.PRODUCT_CATALOG]: [3, 6, 1],
  [TRENDING_TOOL_IDS.FOOD_CATALOG]: [7, 6, 1],
  [TRENDING_TOOL_IDS.AUTOMOBILE_CATALOG]: [8, 6, 1],
};

/** After CSV sync migration: Food = 7, Automobile = 8. */
export const FOOD_CATALOGUE_CATEGORY_ID = 7;
export const AUTOMOBILE_CATALOGUE_CATEGORY_ID = 8;

export function getTrendingToolPresetCategoryIds(toolId) {
  return TRENDING_TOOL_PRESET_CATEGORY_IDS[toolId] ?? null;
}

/** Flatten API categories into one searchable list, preserving category order. */
export function flattenPresetsForTrendingTool(apiCategories, categoryIds) {
  if (!Array.isArray(apiCategories) || !Array.isArray(categoryIds)) return [];

  const byId = new Map(apiCategories.map((cat) => [cat.category_id, cat]));
  const flat = [];

  categoryIds.forEach((categoryId) => {
    const cat = byId.get(categoryId);
    if (!cat?.presets?.length) return;
    const categoryName = cat.category_name || cat.name || "";
    cat.presets.forEach((preset) => {
      flat.push({
        ...preset,
        categoryId,
        categoryName,
        categoryDefaultLabel: cat.default_display_label || "",
      });
    });
  });

  return flat;
}
